let lastTrackedPage = null

const trackPageView = () => {
  const currentPage = window.location.href
  if (currentPage !== lastTrackedPage) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'virtual_page_view',
      page_location: window.location.href,
      ...window.intelligemsMeta,
    })
    lastTrackedPage = currentPage
  }
}

document.addEventListener('DOMContentLoaded', trackPageView)

window.addEventListener('popstate', trackPageView)

const interceptHistoryMethod = (method) => {
  const original = history[method]
  history[method] = (...args) => {
    const result = original.apply(history, args)
    trackPageView()
    return result
  }
}

interceptHistoryMethod('pushState')
interceptHistoryMethod('replaceState')
